import { Route, Routes, Navigate } from "react-router";
import { useAppDrawerContext } from "../shared/contexts/drawer.contexts";
import { useEffect } from "react";
import { PageDeshboard } from "../pages/deshboard/deshboard";
import { EditarCliente } from "../pages/cliente/editar-cliente";
import { ListagemObras } from "../pages/obra/listagem-obras";
import { CriarObra } from "../pages/obra/criar-obra";
import { EditarObra } from "../pages/obra/editar-obra";
import { ListagemFuncionarios } from "../pages/colaborador/listagem-funcionarios";
import { CriarFuncionario } from "../pages/colaborador/criar-funcionario";
import { EditarFuncionario } from "../pages/colaborador/editar-funcionario";
import { ListagemMovimentaoesFinanceira } from "../pages/financeiro/listagem-movimentacoes-financeira";
import { GerarMovimentacaoFinanceira } from "../pages/financeiro/gerar-movimentacao-financeira";
import { CriarCliente } from "../pages/cliente/criar-cliente";
import { ListagemClientes } from "../pages/cliente/listagem-empresas";
import { ListagemUsuarios } from "../pages/usuario/listagem-usuarios";
import { CriarUsuario } from "../pages/usuario/criar-usuario";
import { EditarUsuario } from "../pages/usuario/editar-usuario";
import { Caixa } from "../pages/financeiro/caixa";
import { GerarMovimentacaoObra } from "../pages/movimentacao-obra/gerar-movimentacao";
import { ListarMovimentacaoObra } from "../pages/movimentacao-obra/listar-movimentacao";
import { ListagemEntradaNotas } from "../pages/entrada-de-notas-servicos/listagem-entrada-de-notas";
import { AdicionarNota } from "../pages/entrada-de-notas-servicos/adicionar-nota";
import { EditarNota } from "../pages/entrada-de-notas-servicos/editar-nota";
import { CriarContasPagar } from "../pages/contas-a-pagar/criar-conta-a-pagar";
import { ListarContasAPagar } from "../pages/contas-a-pagar/listagem-contas-a-pagar";
import { EditarContasPagar } from "../pages/contas-a-pagar/editar-conta-a-pagar";
import { LiquidarContaAPagar } from "../pages/contas-a-pagar/liquidar-conta-a-pagar";
import { ListarContasAReceber } from "../pages/contas-a-receber/listagem-contas-a-receber";
import { CriarContasReceber } from "../pages/contas-a-receber/criar-conta-a-receber";
import { EditarContasReceber } from "../pages/contas-a-receber/editar-conta-a-receber";
import { LiquidarContaAReceber } from "../pages/contas-a-receber/liquidar-conta-a-receber";
import { ListagemFornecedores } from "../pages/fornecedores/listagem-fornecedores";
import { CriarFornecedor } from "../pages/fornecedores/criar-fornecedor";
import { EditarFornecedor } from "../pages/fornecedores/editar-fornecedor";
import { AdicionarNotaDeCompra } from "../pages/entrada-de-notas-compra/adicionar-nota";
import { ListagemNotasDeCompras } from "../pages/entrada-de-notas-compra/listagem-entrada-de-notas";
import { EditarNotaDeCompra } from "../pages/entrada-de-notas-compra/editar-nota";
import { ListagemCadastroBancario } from "../pages/cadastro-bancario/listagem-cadastro-bancario";
import { CriarCadastroBancario } from "../pages/cadastro-bancario/cadastro-bancario.schema";
import { EditarCadastroBancario } from "../pages/cadastro-bancario/editar-cadastro-bancario";
import { ListagemCaixaDeEntrada } from "../pages/caixa-de-entrada/lista-caixa-de-entrada.nova";
import { DetalheEmpresa } from "../pages/empresa/detalhe-empresa";
import CriarOrcamento from "../pages/orcamento/criar-orcamento";
import { ListarOrcamentos } from "../pages/orcamento/listar-orcamentos";
import EditarOrcamento from "../pages/orcamento/editar-orcamento";


export function AppRoutes() {
  const { setDrawerOption } = useAppDrawerContext();

  useEffect(() => {
    setDrawerOption([
      {
        path: "/pagina-inicial",
        icon: "home",
        label: "Home",
      },
      {
        path: "/cliente",
        icon: "people",
        label: "Clientes",
      },

      {
        path: "/obras",
        icon: "maps_home_work",
        label: "Obras",
      },

      {
        path: "/colaboradores",
        icon: "account_box",
        label: "Colaboradores",
      },

      {
        path: "/fornecedores",
        icon: "business_center",
        label: "Fornecedores",
      },

      {
        path: "/financeiro",
        icon: "local_atm",
        label: "Financeiro",
        subMenu: [
          {
            path: "/financeiro/caixa",
            icon: "point_of_sale",
            label: "Caixa",
          },
          {
            path: "/financeiro/movimentacoes-obras",
            icon: "engineering",
            label: "Gestão Financeira Obras",
          },
          {
            path: "/financeiro/entrada-notas-servicos",
            icon: "receipt_long",
            label: "Notas de Serviços",
          },

          {
            path: "/financeiro/entrada-notas-compras",
            icon: "shopping_cart",
            label: "Entrada Notas de Compras",
          },

          {
            path: "/financeiro/contas-a-pagar",
            icon: "account_balance_wallet",
            label: "Contas a Pagar",
          },

          {
            path: "/financeiro/contas-a-receber",
            icon: "monetization_on",
            label: "Contas a Receber",
          },
        ],
      },
      {
        path: "/usuarios",
        icon: "person",
        label: "Usuários",
      },

      {
        path: "/orcamentos",
        icon: "description",
        label: "Orçamentos",
      },

      {
        path: "/empresas",
        icon: "domain", // <-- ícone mais apropriado para empresa
        label: "Empresas",
        subMenu: [
          {
            path: "/empresas/detalhe",
            icon: "settings",
            label: "Configurações Gerais",
          },
          {
            path: "/empresas/cadastro-bancario",
            icon: "account_balance",
            label: "Cadastro Bancário",
          },

          /*{
            path: "/empresas/caixa-de-entrada",
            icon: "mail",
            label: "Caixa de Entrada",
          },*/
        ],
      },
    ]);
  }, []);

  return (
    <Routes>
      <Route path="/pagina-inicial" element={<PageDeshboard />} />
      <Route path="/cliente" element={<ListagemClientes />} />
      <Route path="/cliente/criar" element={<CriarCliente />} />
      <Route path="/cliente/detalhe/:id" element={<EditarCliente />} />
      <Route path="/obras" element={<ListagemObras />} />
      <Route path="/obra/criar" element={<CriarObra />} />
      <Route path="/obra/detalhe/:id" element={<EditarObra />} />
      <Route
        path="/obra/servicos-adicionais/:id"
        element={<GerarMovimentacaoObra />}
      />
      <Route
        path="/obra/lista-servicos-adicionais/:id"
        element={<ListarMovimentacaoObra />}
      />
      <Route path="/colaboradores" element={<ListagemFuncionarios />} />
      <Route path="/colaborador/criar" element={<CriarFuncionario />} />
      <Route path="/colaborador/detalhe/:id" element={<EditarFuncionario />} />
      <Route path="*" element={<Navigate to="/pagina-inicial" />} />
      <Route
        path="/financeiro/movimentacoes-obras"
        element={<ListagemMovimentaoesFinanceira />}
      />
      <Route
        path="/financeiro/gerar-movimentacoes"
        element={<GerarMovimentacaoFinanceira />}
      />
      <Route
        path="/financeiro/entrada-notas-servicos"
        element={<ListagemEntradaNotas />}
      />
      <Route
        path="/financeiro/entrada-notas-servicos/adicionar"
        element={<AdicionarNota />}
      />
      <Route
        path="/financeiro/entrada-notas-servicos/adicionar"
        element={<AdicionarNota />}
      />
      <Route
        path="/financeiro/entrada-notas-servicos/detalhe/:id"
        element={<EditarNota />}
      />

      <Route
        path="/financeiro/entrada-notas-compras"
        element={<ListagemNotasDeCompras />}
      />
      <Route
        path="/financeiro/entrada-notas-compra/adicionar"
        element={<AdicionarNotaDeCompra />}
      />

      <Route
        path="/financeiro/entrada-notas-compra/detalhe/:id"
        element={<EditarNotaDeCompra />}
      />

      <Route
        path="/financeiro/contas-a-pagar/criar"
        element={<CriarContasPagar />}
      />
      <Route
        path="/financeiro/contas-a-pagar"
        element={<ListarContasAPagar />}
      />
      <Route
        path="/financeiro/contas-a-pagar/detalhe/:id"
        element={<EditarContasPagar />}
      />
      <Route
        path="/financeiro/contas-a-pagar/liquidar/:id"
        element={<LiquidarContaAPagar />}
      />
      <Route
        path="/financeiro/contas-a-receber"
        element={<ListarContasAReceber />}
      />
      <Route
        path="/financeiro/contas-a-receber/criar"
        element={<CriarContasReceber />}
      />
      <Route
        path="/financeiro/contas-a-receber/detalhe/:id"
        element={<EditarContasReceber />}
      />
      <Route
        path="/financeiro/contas-a-receber/liquidar/:id"
        element={<LiquidarContaAReceber />}
      />
      <Route path="/financeiro/caixa" element={<Caixa />} />
      <Route path="/usuarios" element={<ListagemUsuarios />} />
      <Route path="/usuario/criar" element={<CriarUsuario />} />
      <Route path="/usuario/detalhe/:id" element={<EditarUsuario />} />
      <Route path="/fornecedores" element={<ListagemFornecedores />} />
      <Route path="/fornecedores/criar" element={<CriarFornecedor />} />
      <Route path="/fornecedores/detalhe/:id" element={<EditarFornecedor />} />

      <Route path="/empresas/detalhe" element={<DetalheEmpresa />} />

      <Route path="/empresas/cadastro-bancario" element={<ListagemCadastroBancario />} />
      <Route path="/empresas/cadastro-bancario/criar" element={<CriarCadastroBancario />} />
      <Route path="/empresas/cadastro-bancario/detalhe/:id" element={<EditarCadastroBancario />} />

      <Route path="/empresas/caixa-de-entrada" element={<ListagemCaixaDeEntrada />} />

      <Route path="/orcamento/criar" element={<CriarOrcamento />} />
      <Route path="/orcamentos" element={<ListarOrcamentos />} />
      <Route path="/orcamento/detalhe/:id" element={<EditarOrcamento />} />

    </Routes>
  );
}
